import { Component, OnDestroy, OnInit } from '@angular/core';
import { NotificationGlobalService } from './services/notification-global.service';
import { MatDialog } from '@angular/material/dialog';
import { BlockAppDialogComponent } from './shared/block-app-dialog/block-app-dialog.component';
// import { Deeplinks } from '@ionic-native/deeplinks/ngx';
import { Router, RouterOutlet } from '@angular/router';
import { AuthService } from './shared/auth/auth.service';
import { NavigateService } from './services/navigate.service';
import { Subject } from 'rxjs';
import { UtilityService } from './services/utility.service';
import { UsersInfoService } from './services/users-info.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { MatSnackBar } from '@angular/material/snack-bar';

// TODO: Find replacement for Deeplinks
@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css'],
	imports: [RouterOutlet],
	standalone: true
})
export class AppComponent implements OnInit, OnDestroy {
	unsubcribe$ = new Subject<void>();
	title = 'app';

	constructor(
		private dialog: MatDialog,
		private notificationServices: NotificationGlobalService,
		// private deeplinks: Deeplinks,
		private router: Router,
		private snackBar: MatSnackBar,
		private authService: AuthService,
		private navigateService: NavigateService,
		private utilityService: UtilityService,
		private _userInfoService: UsersInfoService,
		private permissionsService: NgxPermissionsService
	) {}

	ngOnInit() {
		// this.openDeeplinks();
		document.addEventListener('deviceready', (event) => {
			this.checkVersion();
			// this.openDeeplinks();
		});
		document.addEventListener('resume', (event) => {
			// this.openDeeplinks();
		});
		window.addEventListener('touchstart', (event) => {
			this.utilityService.announceScroll();
		});
		const group = this._userInfoService.getUserGroup();
		if (group) {
			this.permissionsService.loadPermissions(['LEVEL' + group.Type]);
		}
	}

	checkVersion() {
		this.notificationServices.checkAppVersion().subscribe(
			(data) => {},
			(err) => {
				if (err.error.text == 'False') {
					this.dialog.closeAll();
					return this.dialog.open(BlockAppDialogComponent, {
						disableClose: true,
						width: '250px',
						data: {
							title: 'Update Required',
							body: 'Please install the latest mobile version'
						}
					});
				}
			}
		);
	}

	// openDeeplinks() {
	// 	this.deeplinks
	// 		.route({
	// 			'/navigate-details/:controller/:action/:params': NavigateDetailsComponent
	// 		})
	// 		.pipe(takeUntil(this.unsubcribe$))
	// 		.subscribe(
	// 			(match) => {
	// 				const params = match.$args;
	// 				this.navigateService.setParamsToStorage(params);
	// 				this.authService
	// 					.isLoggedIn()
	// 					.pipe(takeUntil(this.unsubcribe$))
	// 					.subscribe((data) => {
	// 						if (data) {
	// 							this.navigateService.navigateMobile(params);
	// 						}
	// 					});
	// 			},
	// 			(nomatch) => {}
	// 		);
	// }

	ngOnDestroy(): void {
		this.unsubcribe$.next();
		this.unsubcribe$.complete();
	}
}
